/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Square_Brackets_DescInputs */



/**
* | output |
* | --- |
* | "Removes content within square brackets" |
*
* @param {Remove_Square_Brackets_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_square_brackets_desc = /** @type {((inputs?: Remove_Square_Brackets_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Square_Brackets_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprime le contenu entre crochets")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entfernt den Inhalt innerhalb eckiger Klammern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuove il contenuto tra parentesi quadre")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удаляет содержимое внутри квадратных скобок.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elimina el contenido entre corchetes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除方括号内的内容")
	if (locale === "ja") return /** @type {LocalizedString} */ ("角括弧内のコンテンツを削除します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्गाकार कोष्ठकों के भीतर की सामग्री को हटाता है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remove o conteúdo entre colchetes")
	return /** @type {LocalizedString} */ ("Removes content within square brackets")
});